<div class="footer-copy text-center">
  © 2026 Copyright Accenture. All Rights Reserved. For internal use only.
</div>
<!-- <footer class="page-footer font-small  lighten-3 pt-3" id="footer">
  <div class="container text-center">
    <div class="row rowheader text-center justify-content-center contactFooter">
      <span class="fontCss mb-2">Please feel free to write to us at
        <a href="mailto:asd.support@accenture.com" class="text-lowercase font-weight-bold"
          style="text-decoration:underline; color: white;"> asd.support&#64;accenture.com </a>
        for application support.
      </span>
      <span class="fontCss"> There is a dedicated support team working from India Delivery Centre.</span>
    </div>
  </div>
  <hr>

  <div class="container-fluid footer-container">
    <div class="d-flex flex-wrap justify-content-center align-items-center footer-menu">
      <a href="#" class="footer-link">Home</a>&nbsp;&nbsp;
      <a class="footer-link footerBorder" data-toggle="modal" data-target="#modalDefaultContactForm"
        (click)="getContactElementDetails()">
        Contact Us
      </a>
      <a class="footer-link footerBorder" data-toggle="modal" data-target="#scrollModal"
        (click)="getElementDetails('hana')">
        S/4 Hana
      </a>
      <a class="footer-link footerBorder" data-toggle="modal" data-target="#scrollModal"
        (click)="getElementDetails('ecc')">
        ECC
      </a>
      <a class="footer-link footerBorder" data-toggle="modal" data-target="#scrollModal"
        (click)="getElementDetails('bw')">
        BW
      </a>
      <a class="footer-link footerBorder" data-toggle="modal" data-target="#scrollModal"
        (click)="getElementDetails('apo')">
        APO
      </a>
      <a class="footer-link footerBorder" data-toggle="modal" data-target="#scrollModal"
        (click)="getElementDetails('utilities')">
        IS-Utilities
      </a>
      <a class="footer-link footerBorder" data-toggle="modal" data-target="#scrollModal"
        (click)="getElementDetails('upstream')">
        IS Energy-Upstream
      </a>
      <a class="footer-link footerBorder" data-toggle="modal" data-target="#scrollModal"
        (click)="getElementDetails('downstream')">
        IS Energy-Downstream
      </a>
    </div>
    <div class="footer-copy text-center">
      © 2026 Copyright Accenture. All Rights Reserved. For internal use only.
    </div>
  </div>
</footer> -->